import React from 'react';
import { fmt } from './aiqMeta';

const Section = ({ title, children, testId }) => (
  <div className="border rounded-md" data-testid={testId}>
    <div className="px-3 py-2 bg-zinc-50 text-xs font-semibold uppercase text-zinc-600 border-b">{title}</div>
    <div className="max-h-[360px] overflow-y-auto">{children}</div>
  </div>
);

const Empty = () => <p className="px-3 py-6 text-center text-sm text-zinc-500">Nothing synced yet.</p>;

export const ReferenceDataPanel = ({ data }) => (
  <div className="grid lg:grid-cols-3 gap-4" data-testid="aiq-reference">
    <Section title="Tax codes" testId="aiq-ref-tax">
      {!data?.tax_codes?.length ? <Empty /> : (
        <table className="w-full text-sm">
          <tbody className="divide-y divide-zinc-100">
            {data.tax_codes.map((t) => (
              <tr key={t.code}>
                <td className="px-3 py-1.5 font-mono text-xs">{t.code}</td>
                <td className="px-3 py-1.5">{t.description}{t.is_default && <span className="ml-1 text-[10px] text-emerald-700">default</span>}</td>
                <td className="px-3 py-1.5 text-right font-mono">{fmt(t.rate, 2)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Section>
    <Section title="Currencies" testId="aiq-ref-currencies">
      {!data?.currencies?.length ? <Empty /> : (
        <table className="w-full text-sm">
          <tbody className="divide-y divide-zinc-100">
            {data.currencies.map((c) => (
              <tr key={c.code}>
                <td className="px-3 py-1.5 font-mono text-xs">{c.code}{c.is_base && <span className="ml-1 text-[10px] text-emerald-700">base</span>}</td>
                <td className="px-3 py-1.5">{c.description || ''}</td>
                <td className="px-3 py-1.5 text-right font-mono">{c.exchange_rate ? fmt(c.exchange_rate, 4) : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Section>
    <Section title="Price lists" testId="aiq-ref-pricelists">
      {!data?.price_lists?.length ? <Empty /> : (
        <table className="w-full text-sm">
          <tbody className="divide-y divide-zinc-100">
            {data.price_lists.map((p) => (
              <tr key={p.price_list_id || p.code}>
                <td className="px-3 py-1.5 font-mono text-xs">{p.code || p.price_list_id}{p.is_default && <span className="ml-1 text-[10px] text-emerald-700">default</span>}</td>
                <td className="px-3 py-1.5">{p.description}</td>
                <td className="px-3 py-1.5 text-right text-xs text-zinc-600 font-mono">{p.item_count} prices · {p.customer_specific} customer</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Section>
  </div>
);
